<template>
  <div
    class="tw-flex tw-flex-row tw-justify-center tw-space-x-4 tw-rounded-md tw-border tw-border-amber-400 tw-bg-amber-50 tw-py-4"
  >
    <div class="tw-text-6xl tw-text-yellow-400">
      {{ summary.average }}
    </div>
    <div>
      <div class="tw-mt-2 tw-flex">
        <div
          type="button"
          v-for="i in highlightedStars"
          class="tw-focus:outline-none"
          :class="{ 'tw-mr-1': i <= highlightedStars }"
          :key="i"
        >
          <RatingStar class="tw-text-xl" :starColor="'#ffb500'" />
        </div>
        <div type="button" v-if="halfFadedStar" class="tw-focus:outline-none" :class="'tw-mr-1'">
          <RatingStarHalf class="tw-text-xl" :primaryColor="'#ffb500'" :secondaryColor="'#fef1d1'" />
        </div>
        <div
          type="button"
          v-for="i in fadedStars"
          class="tw-focus:outline-none"
          :class="{ 'tw-mr-1': i < fadedStars }"
          :key="i"
        >
          <RatingStar class="tw-text-xl" :starColor="'#fef1d1'" />
        </div>
      </div>
      <div class="tw-mt-2 tw-text-sm tw-text-gray-700">{{ reviewsCountText }}</div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';

const props = defineProps({
  summary: Object,
});

let highlightedStars = ref(0);
let fadedStars = ref(0);
let halfFadedStar = ref(false);

const starCount = 5;

const reviewsCountText = computed(
  () => Number(props.summary.total).toLocaleString() + ' Review' + (props.summary.total > 1 ? 's' : '')
);

onMounted(async () => {
  const ratingPoints = props.summary.average;
  let highlightedStarsCount = Math.floor(ratingPoints);
  const fraction = (ratingPoints - highlightedStarsCount).toFixed(1);
  let fadedStarCounts = starCount - highlightedStarsCount;

  if (fraction >= 0.1 && fraction < 0.7) {
    halfFadedStar.value = true;
    fadedStarCounts = starCount - highlightedStarsCount - 1;
  }

  if (fraction >= 0.7) {
    halfFadedStar.value = false;
    highlightedStarsCount += 1;
    fadedStarCounts = starCount - highlightedStarsCount;
  }

  fadedStars.value = fadedStarCounts;
  highlightedStars.value = highlightedStarsCount;
});
</script>
